export const ix_config = {

  coppa__false: {
    'efe_hp_728': {
      siteId: '391336',
    },

    'efe_topics_160': {
      siteId: '391337',
    },

    'efe_topics_bottom_728': {
      siteId: '391333',
    },

    'efe_topics_mid_728_1': {
      siteId: '391334',
    },
    'efe_topics_mid_728_2': {
      siteId: '391335'
    },
    'efe_topics_mid_728_3': {
      siteId: '391339'
    },
    'efe_300_mid': {
      siteId: '396039'
    },
    'EFE_PDF_Top': {
      siteId: '435619'
    },
    'EFE_PDF_Bottom': {
      siteId: '435620'
    },
    'EFE_Right_Sticky': {
      siteId: '435621'
    }



  }


}
